import React, { Dispatch, SetStateAction, useState } from 'react';
import { Backdrop, Button, Fade, Grid, makeStyles } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import { VcGrid, EvenlyGrid } from '../Grid';
import Select, { Ioption } from '../Material/Select';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    // width: 300,
    // height: 200,
    display: 'flex',
    flexDirection: 'column',
  },
}));

interface IuserListModal {
  optionList: Ioption[];
  _open: [boolean, Dispatch<SetStateAction<boolean>>];
  onConfirm: (val: string) => void;
}

const UserListModal = (props: IuserListModal): JSX.Element => {
  const {
    optionList = [],
    onConfirm,
    _open: [open, setOpen],
  } = props;

  const [selectedUserId, setSelectedUserId] = useState('');
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      disableBackdropClick
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <Grid container>
            <VcGrid item xs={12}>
              查到多筆資料，請選擇使用者：
            </VcGrid>
            <Grid item xs={12}>
              <Select
                // placeholder="快遞倉站清單"
                value={selectedUserId}
                onChange={(e) => {
                  setSelectedUserId(e.target.value);
                }}
                options={optionList}
              />
            </Grid>
          </Grid>
          <Grid container>
            <EvenlyGrid item xs style={{ margin: '1em 0' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  onConfirm(selectedUserId);
                  setOpen(false);
                }}
              >
                確定
              </Button>
              <Button variant="contained" onClick={() => setOpen(false)}>
                取消
              </Button>
            </EvenlyGrid>
          </Grid>
        </div>
      </Fade>
    </Modal>
  );
};
export default UserListModal;
